<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="create-time-based-subchannel-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Create Subchannel
            </h4>
          </div>

          <LoadingSpinner v-if="loading"/>

          <div v-else class="modal-body">
            <TextFormGroup
                v-model="data.name"
                name="name"
                label="Name"
                :error="getError('name')"
            />

            <ColorFormGroup
                v-model="data.color"
                name="color"
                label="Color"
                :error="getError('color')"
                :colors="colors"
            />

            <SelectFormGroup
                v-model="data.category"
                name="category"
                label="Time Subchannel Category"
                :error="getError('category')"
                :options="timeSubchannelCategoryOptions"
            />

          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import ColorFormGroup from '@/components/FormGroups/Block/Color'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'
import LoadingSpinner from "../../../Layout/LoadingSpinner.vue";

export default {
  components: {ColorFormGroup, LoadingSpinner,SelectFormGroup, TextFormGroup},

  mixins: [Errors],

  props: {
    timeBasedChannel: {
      required: true
    }
  },

  data() {
    return {
      data: {},

      colors: null,
      timeSubchannelCategories: null,
      loading: true
    }
  },

  mounted() {
    this.load()

    this.listenForClose()
  },

  computed: {
    timeSubchannelCategoryOptions() {
      return this.timeSubchannelCategories.map(timeSubchannelCategory => ({
        value: timeSubchannelCategory.id,
        label: timeSubchannelCategory.attributes.name
      }))
    }
  },

  methods: {
    load() {
      Promise.all([
        http.get('/api/v2/colors'),
        http.get('/api/v2/time-subchannel-categories')
      ]).then(responses => {
        this.colors = responses[0].data.data

        this.timeSubchannelCategories = responses[1].data.data

        this.loading = false

      })
    },

    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/time-based-subchannels', {
        ...this.data,
        time_based_channel_id: this.timeBasedChannel.id,
      })
          .then(response => {
            notify.success('The subchannel was saved')

            this.$emit('created', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(error => {
            if (error.response.status === 400) {
              return notify.error(error.response.data.message)
            }

            throw error
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
